import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import type { ITicketOpenBanking } from './TicketOpenBanking.interface';
import { TicketOpenBankingType } from './TicketOpenBanking.enum';

export default class TicketOpenBanking implements ITicketOpenBanking {
  idContact: string;
  userId: string;
  type: TicketOpenBankingType;
  isFinished: boolean;
  finishedTimeStamp: number;
  hasData: boolean;

  static build = (data: ITicketOpenBanking) => new TicketOpenBanking(data);
  static blank = () => new TicketOpenBanking();

  /**
   * Constructor
   * @param {ITicketOpenBanking} data
   */
  constructor(data?: ITicketOpenBanking) {
    this.idContact = toUUID(data?.idContact);
    this.userId = toUUID(data?.userId);
    this.type = TicketOpenBankingType.of(data?.type?.name);
    this.isFinished = data?.isFinished === true;
    this.finishedTimeStamp = data?.finishedTimeStamp ? epoch(utc(data?.finishedTimeStamp)) : 0;
    this.hasData = data?.hasData === true;
  }
}
